// src/hooks/usePresence.ts
import { useEffect } from "react";
import { socket } from "@/lib/socket";
import { useLocation } from "react-router-dom";
import { useAuth } from "./useAuth";

export function usePresence() {
    const { user } = useAuth();
    const location = useLocation();

    useEffect(() => {
        if (!user) return;

        const presencePayload = {
            userRole: user.role,
            dealerRoom: user.dealerId,
            page: location.pathname,
            vehicleId: user.vehicleId,
        };

        socket.emit("presence", presencePayload);
    }, [user, location]);
}
